
export const UserBotIT = [
  [
    {
      balloon: 'La nostra relazione non sta funzionando. E non sono io… sei tu!'
    }
  ],
  [
    {
      balloon: 'I ghiacciai si stanno sciogliendo <span class="emoji">🏔️ 🏔️ ➡️ 💦</span>'
    },
    {
      balloon: 'Le foreste stanno bruciando <span class="emoji">🌲 🌲 🌲 ➡️ 🔥</span>'
    },
    {
      balloon: 'Gli animali stanno morendo <span class="emoji">🐧 🐳 🐯 🐘 ➡️ 😵</span>' 
    },
    {
      balloon: 'Ti stanno a cuore i nostri problemi? Perché non sono mica solo miei...' 
    }
  ],
  [
    {
      balloon: 'Dice quello/a che vuole lasciarmi per Marte...<span class="emoji">🙄</span>'
    }
  ],
  [
    {
      balloon: 'Lo so, stavo scherzando. Ecco come possiamo rimediare! <span class="emoji">💪</span>'
    }
  ],
  [
    {
      balloon: 'Un modo per <span class="emoji">🛑</span>  i cambiamenti climatici...'
    },
    {
      balloon: 'è aggiustare il nostro rapporto con <span class="emoji">🥒 🧀 🍕🍦</span>'
    }
  ],
  [
    {
      balloon: 'Sì! La maggior parte dei problemi, in effetti, ha a che fare con ciò che mangiamo <span class="emoji">😞</span>',
      toggleAvatar: true
    },
    {
      balloon: 'Quindi oggi ti svelerò come puoi aprire la mente <span class="emoji">🧠</span> prima della bocca <span class="emoji">👄</span>'
    },
    {
      balloon: 'Pronto/a?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🧑‍🏫</span> Cominciamo con qualche indovinello veloce per soddisfare la tua fame di sapere!'
    },
    {
      balloon: 'Molti di voi pensano che il problema più grande che abbiamo con il cibo sia di non averne abbastanza... ma TU cosa pensi?'
    },
    {
      balloon: 'Sono di più le persone che soffrono di obesità o di denutrizione?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> Sebbene più di 690 milioni di persone siano denutrite, 2,1 miliardi sono obese o sovrappeso.',
      balloonWrong: '<span class="emoji">👎</span> Oltre 690 milioni di persone sono denutrite, ma 2,1 miliardi sono obese o sovrappeso '
    },
    {
      balloon: 'Capisci, anche se un sacco di persone non hanno abbastanza cibo… quelle che ne hanno troppo sono moooolte di più!',
      balloonWrong: 'Capisci, anche se un sacco di persone non hanno abbastanza cibo… quelle che ne hanno troppo sono moooolte di più!'
    }
  ],
  [
    {
      balloon: 'E quella è solo la punta dell’iceberg:... Proviamo questa:'
    },
    {
      balloon: 'Pensi che dovremmo sprecare il cibo <span class="emoji">🗑️</span>'
    },
    {
      balloon: 'o nutrire chi soffre la fame ?'
    }
  ],
  [
    {
      balloon: 'Mi fa piacere che TU la pensi così, ma...'
    },
    {
      balloon: 'quanto cibo pensi viene sprecato o perduto ogni anno?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> Purtroppo, è giusto...',
      balloonWrong: '<span class="emoji">👎</span> Purtroppo è di più, molto di più...'
    },
    {
      balloon: 'Ogni anno, le <span class="emoji">⛰️⛰️⛰️</span> di cibo che vengono sprecate o perdute dalla produzione al frigorifero, senza nemmeno arrivare a tavola, ammontano a 1,3 miliardi di tonnellate.',
      balloonWrong: 'Ogni anno, le <span class="emoji">⛰️⛰️⛰️</span> di cibo che vengono sprecate o perdute dalla produzione al frigorifero, senza nemmeno arrivare a tavola, ammontano a 1,3 miliardi di tonnellate.'
    }
  ],
  [
    {
      balloon: 'Oltre a bastare per sfamare tutti, quel cibo può anche contribuire a nutrire TUTTO.'
    },
    {
      balloon: 'Perché non siamo gli unici a consumare cibo... il che ci porta alla prossima domanda:'
    },
    {
      balloon: 'Dovremmo nutrire le <span class="emoji">🤝‍🧑</span> , gli <span class="emoji">🐖 🐄</span> , o le <span class="emoji">🚗 🚗</span> ?'
    }
  ],
  [
    {
      balloon: 'Oh sì, eccome!'
    },
    {
      balloon: 'Solo il 67% della produzione mondiale di cereali viene effettivamente destinato all’alimentazione umana.'
    },
    {
      balloon: 'L’altro 27% viene usato per nutrire gli animali e il 9% serve a produrre biocombustibile per alimentare industrie e veicoli, come le vostre voraci automobili.'
    }
  ],
  [
    {
      balloon: 'Lo so <span class="emoji">😔</span>'
    },
    {
      balloon: 'È perché rappresentano alcuni dei problemi globali che voi umani state affrontando al giorno d’oggi! Che sono decisamente trooooppo grandi da risolvere da soli per un <span class="emoji">🧑</span> e un <span class="emoji">🌍</span>...'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👫</span> LAVORO DI SQUADRA! <span class="emoji">👫</span>'
    },
    {
      balloon: 'Vivere sano e rispettarsi reciprocamente è qualcosa che dobbiamo fare TUTTI...'
    },
    {
      balloon: 'INSIEME!'
    },
    {
      balloon: 'Fortunatamente molti paesi, agricoltori, pescatori e cittadini si sono uniti per fissare obiettivi comuni per un futuro migliore in grado di aiutarci a vivere in modo sostenibile, reimpostando i sistemi alimentari dal campo <span class="emoji">🧑‍🌾</span> alla tavola <span class="emoji">🍴</span> '
    },
    {
      balloon: 'Vuoi sapere cosa mi rende orgoglioso di essere il vostro pianeta? <span class="emoji">😍</span>'
    }
  ],
  [
    {
      balloon: 'È ora di collaborare per creare un futuro migliore, un obiettivo alla volta!'
    },
    {
      balloon: 'Scopri perché il cibo è un fattore importante per aiutarci a raggiungerli.'
    },
    {
      balloon: 'SDGS'
    }
  ],
  [
    {
      balloon: 'Come vedi, i comportamenti individuali intelligenti sono molto importanti! Non si tratta solo di capire i problemi che dobbiamo affrontare, ma anche di comprendere che tutti insieme possiamo contribuire al cambiamento che vuoi vedere nel mondo!'
    }
  ],
  [
    {
      balloon: 'Non così in fretta! <span class="emoji">✋</span>'
    },
    {
      balloon: 'Questi sono solo gli obiettivi di <b>TUTTA</b> l’umanità, ma ci occorre ancora che <b>TU</b> faccia la tua parte per raggiungerli! '
    },
    {
      balloon: 'LOGOANIM'
    },
    {
      balloon: 'Sei pronto/a a scoprire come <b>TU</b> puoi aiutare?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👷</span>  Ora che hai costruito solide basi per aggiustare il nostro rapporto con il cibo, forse puoi contribuire a creare città e comunità più sane e più felici!'
    },
    {
      balloon: '<span class="emoji">👀</span>  Ma attenzione ! <span class="emoji">👀</span>  Nutrire una città intera non è facile. <span class="emoji">😰</span>'
    },
    {
      balloon: 'Sempre più persone vivono in città che diventano ogni giorno più grandi... come si ripercuote questo sul rapporto tra esseri umani e cibo? '
    },
    {
      balloon: 'Scoprilo cercando di rispondere a queste domande! '
    }
  ],
  [
    {
      balloon: 'Dove vive attualmente la maggior parte delle persone nel mondo?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> Nel 2019, il 55% della popolazione mondiale viveva in città. Questo è un grave problema, perché nei prossimi 30 anni si trasferiranno in città 2,5 miliardi di persone. Le città e le aree rurali circostanti devono lavorare fianco a fianco per garantire sistemi alimentari sostenibili. Perciò, se lasciamo la campagna incolta, non saremo in grado di produrre abbastanza cibo per tutti.',
      balloonWrong: '<span class="emoji">👎</span> Nel 2019, il 55% della popolazione mondiale viveva in città. Questo è un grave problema, perché nei prossimi 30 anni si trasferiranno in città 2,5 miliardi di persone. Le città e le aree rurali circostanti devono lavorare fianco a fianco per garantire sistemi alimentari sostenibili. Perciò, se lasciamo la campagna incolta, non saremo in grado di produrre abbastanza cibo per tutti.'
    },
    {
      balloon: 'Quante persone vivranno in città nel 2050?',
      balloonWrong: 'Quante persone vivranno in città nel 2050?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> Nel 2050, quasi il 70% della popolazione mondiale (secondo le stime, 10 miliardi di persone) vivrà in città, soprattutto in Asia e Africa. Questo contribuirà a cambiare il modo di produrre, distribuire, vendere e consumare il cibo.',
      balloonWrong: '<span class="emoji">👎</span>  Nel 2050, quasi il 70% della popolazione mondiale (secondo le stime, 10 miliardi di persone) vivrà in città, soprattutto in Asia e Africa. Questo contribuirà a cambiare il modo di produrre, distribuire, vendere e consumare il cibo.'
    },
    {
      balloon: 'Quante megalopoli (città con più di 10 milioni di abitanti) ci saranno nel 2030?',
      balloonWrong: 'Quante megalopoli (città con più di 10 milioni di abitanti) ci saranno nel 2030?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> Esistono già 33 megalopoli, e si calcola che entro il 2030 saranno più di 40, situate soprattutto in Asia e Africa.',
      balloonWrong: '<span class="emoji">👎</span> Esistono già 33 megalopoli, e si calcola che entro il 2030 saranno più di 40, situate soprattutto in Asia e Africa.'
    },
    {
      balloon: 'Quanti abitanti di New York soffrono di insicurezza alimentare a causa del Covid-19?',
      balloonWrong: 'Quanti abitanti di New York soffrono di insicurezza alimentare a causa del Covid-19?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> A New York, la pandemia di Covid-19 ha privato 2 milioni di persone della possibilità di procurarsi regolarmente cibo sostenibile. Questo dimostra che la nostra già inefficace distribuzione alimentare è tutt’altro che preparata per circostanze impreviste come una pandemia globale e che occorre cambiarla radicalmente per garantire che nessuno soffra la fame!',
      balloonWrong: '<span class="emoji">👎</span> A New York, la pandemia di Covid-19 ha privato 2 milioni di persone della possibilità di procurarsi regolarmente cibo sostenibile. Questo dimostra che la nostra già inefficace distribuzione alimentare è tutt’altro che preparata per circostanze impreviste come una pandemia globale e che occorre cambiarla radicalmente per garantire che nessuno soffra la fame!'
    },
    {
      balloon: 'Che cos’è un banco alimentare?',
      balloonWrong: 'Che cos’è un banco alimentare?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> Un banco alimentare senza scopi di lucro è un’organizzazione che distribuisce cibo a chi ha difficoltà a comprarne abbastanza da non soffrire la fame. I banchi alimentari, inoltre, rappresentano una soluzione per ridurre lo spreco direttamente nelle città creando collaborazioni virtuose tra settore pubblico e privato.',
      balloonWrong: '<span class="emoji">👎</span> Un banco alimentare senza scopi di lucro è un’organizzazione che distribuisce cibo a chi ha difficoltà a comprarne abbastanza da non soffrire la fame. I banchi alimentari, inoltre, rappresentano una soluzione per ridurre lo spreco direttamente nelle città creando collaborazioni virtuose tra settore pubblico e privato.'
    },
    {
      balloon: '👏 Ora che hai imparato come nutrire un’intera città, vediamo come puoi nutrirti tu in un modo che sia buono per te e buono per me.<span class="emoji">😉</span> Sei pronto/a a fare un viaggio alle grandi piramidi? <span class="emoji">✈️</span>',
      balloonWrong: '👏 Ora che hai imparato come nutrire un’intera città, vediamo come puoi nutrirti tu in un modo che sia buono per te e buono per me.<span class="emoji">😉</span> Sei pronto/a a fare un viaggio alle grandi piramidi? <span class="emoji">✈️</span>'
    }
  ],
  [
    {
      balloon: 'Pronto/a?'
    }
  ],
  [
    {
      balloon: 'Ora che hai imparato a distinguere gli alimenti che fanno bene da quelli che dovresti consumare con moderazione, mettiamo alla prova questa conoscenza portandoti al ristorante dove si mangia meglio!'
    }
  ],
  [
    {
      balloon: 'Penso che abbiamo fatto un buon lavoro analizzando il modo in cui bisogna pensare al cibo.'
    },
    {
      balloon: 'Pensi di essere pronto/a per impegnarti ogni giorno a mangiare sempre più alimenti sani?'
    }
  ],
 [
    {
      balloon: "Ma aspetta, la tua missione non finisce qui!"
    },
    {
      balloon: "La cosa migliore che puoi fare per mantenere me felice ed entrambi in salute... "
    },
    {
      balloon: "è creare passaparola con  la tua famiglia e coi tuoi amici a scuola parlando del cibo e di me, il pianeta!"
    },
    {
      balloon: "Perché ogni voce e ogni gesto fanno la differenza per il nostro futuro!"
    }
  ],
  [
    {
      balloon: 'Sì, dobbiamo imparare a convivere 😂'
    }
  ] 
]